import styled, { css } from '@xstyled/styled-components';
import { animated } from '@react-spring/web';
import { jumpAnimation } from '~/ui/animation';
import { AnyStyledComponent } from 'styled-components';

const AnimatedDiv = animated.div as AnyStyledComponent;
export const FrontWrapper = styled(AnimatedDiv)<{ correct?: string }>`
  grid-row: 1;
  grid-column: 1;
  ${p => {
    if (p.correct === 'false') {
      return css`
        &:after {
          content: '!';
          color: white;
          position: absolute;
          width: 28px;
          height: 28px;
          border-radius: 14px;
          background-color: redDark;
          top: -14px;
          right: -14px;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: ${jumpAnimation('0px', '5px', '0px')} 0.7s linear infinite;
        }
      `;
    } else if (p.correct === 'true') {
      return css`
        &:after {
          content: '✔';
          color: white;
          position: absolute;
          width: 28px;
          height: 28px;
          border-radius: 14px;
          background-color: greenDark;
          top: -14px;
          right: -14px;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: ${jumpAnimation('0px', '5px', '0px')} 0.7s linear infinite;
        }
      `;
    }
  }}
`;
